import axios from "axios";
import JWT from "./JWT";

//api url
// const url = "https://localhost:8000/api/da";
const url = "https://api.mdr.tbtheunion.com/api/da";

const apiClient = axios.create({
    baseURL: url,
});

apiClient.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${JWT.getToken()}`;
    //Config is the object of AxiosRequestConfig which contains URL, base URL, headers request, body data, response type, timeout, etc.
    return config;
});

export default apiClient;